import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.disabled = false
    this.element.querySelector(".loading")?.classList.add("hidden")
  }

  disconnect() {
    this.#cleanup()
  }

  submit(_event) {
    const formTargetSelector = this.data.get("formTarget")
    const formTarget = document.querySelector(formTargetSelector)

    if (!formTarget) {
      console.error("submit-button: formTarget not found:", formTargetSelector)
      return
    }

    this.element.disabled = true
    this.element.querySelector(".loading")?.classList.remove("hidden")

    // Listen for turbo:submit-end to re-enable on failure
    this.#boundSubmitEnd = this.#handleSubmitEnd.bind(this)
    formTarget.addEventListener("turbo:submit-end", this.#boundSubmitEnd, { once: true })

    // Safety timeout: re-enable after 15s if no Turbo event fires (e.g. network failure)
    this.#safetyTimeout = setTimeout(() => {
      this.#reenable()
      formTarget.removeEventListener("turbo:submit-end", this.#boundSubmitEnd)
    }, 15000)

    formTarget.requestSubmit()
  }

  // --- private ---

  #boundSubmitEnd = null
  #safetyTimeout = null

  #handleSubmitEnd(event) {
    clearTimeout(this.#safetyTimeout)

    // On success the page will redirect/navigate, so disabled state doesn't matter.
    // On failure (4xx/5xx), re-enable so the user can fix errors and resubmit.
    if (!event.detail?.success) {
      this.#reenable()
    }
  }

  #reenable() {
    this.element.disabled = false
    this.element.querySelector(".loading")?.classList.add("hidden")
  }

  #cleanup() {
    if (this.#safetyTimeout) {
      clearTimeout(this.#safetyTimeout)
      this.#safetyTimeout = null
    }
  }
}
